import React from "react";
import BaseLiveItem from "./BaseLiveItem";
import { COMPANY_DOMAINS } from "@routebot/constants";

const LivePersonelItem = ({ itemId }) => {
  return <BaseLiveItem itemId={itemId} mode={COMPANY_DOMAINS.PERSONEL} />;
};

export default LivePersonelItem;
